/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_VALUE,
  ALL_SELECT_VALUE_STRING,
} from '../../../utils/constants/global-constants'
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'

interface QuickLinks {
  'AssignedComponent/MetadataValue': string
  AssignedComponentCode: number
  IsArchived: boolean
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date
  ItemModifiedBy: any //Person_Single
  'Section/MetadataValue'
  SectionCode: number
  'ServicingMAJCOM/MetadataValue': string
  ServicingMAJCOMCode: number
  Title: string
  Url: string
  eKey: string
  eTag: string
}
interface QuickLinksArgs {
  assignedComponentFilter?:number
  assignedComponentOptions?: any
  isArchivedFilter: false | null | true
  isAscending?: boolean
  majcomOptions?: any
  orderBy?: string
  roleContext?: any
  sectionCodeFilter?: number
  sectionOptions?: any
  servicingMAJCOMFilter?:number
  squadronFilter?: any
  squadronOptions?: any
}
const COLUMN_NAMES = {
  'AssignedComponent/MetadataValue': 'AssignedComponent/MetadataValue',
  AssignedComponentCode: 'AssignedComponentCode',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
  Section: 'Section',
  SectionCodes: 'SectionCodes',
  'ServicingMAJCOM/MetadataValue': 'ServicingMAJCOM/MetadataValue',
  ServicingMAJCOMCode: 'ServicingMAJCOMCode',
  Squadron: 'Squadron',
  Title: 'Title',
  Url: 'Url',
  eKey: 'eKey',
  eTag: 'eTag',
}
const LIST_NAME = 'QuickLinksList'

const constructQuickLinksFilter = (args: QuickLinksArgs): string => {

  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchivedFilter ?? null))
  if (args.sectionCodeFilter && args.sectionCodeFilter !== ALL_SELECT_VALUE) {
    filters.push(`contains(SectionCodes, '${args.sectionCodeFilter}')`)
  } else if (args.sectionCodeFilter && 
    args.sectionCodeFilter === ALL_SELECT_VALUE && 
    args.sectionOptions.length > 0) {
    let filter = ''
    args.sectionOptions.forEach((section, ) => {
      if(section.value !== -1) {
        if (filter === '') {
          if (section.majcom) {
            filter += `((contains(SectionCodes, '${section.value}') and (ServicingMAJCOMCode eq ${section.majcom} or ServicingMAJCOMCode eq null)`
          } else {
            filter += `(contains(SectionCodes, '${section.value}')`
          }
        } else {
          if (section.majcom) {
            filter += ` or (contains(SectionCodes, '${section.value}') and (ServicingMAJCOMCode eq ${section.majcom} or or ServicingMAJCOMCode eq null)))`
          } else {
            filter += ` or contains(SectionCodes, '${section.value}')`
          }
        }
      }
      return
    })
    if (filter !== '') filter += ` or SectionCodes eq '[]')`
    filters.push(filter)
  }

  if (
    args.squadronFilter &&
    args.squadronFilter !== ALL_SELECT_VALUE_STRING &&
    args.squadronFilter !== ALL_SELECT_VALUE
  ) {
    if ((args.roleContext && (
      args.roleContext.isCPOwner || 
      args.roleContext.isAssignedComponentOwner ||
      args.roleContext.isMAJCOMOwner
    ))) {
      filters.push(`(Squadron eq '${args.squadronFilter}')`)
    } else if (!args.roleContext) {
      filters.push(`(Squadron eq '${args.squadronFilter}' or Squadron eq null)`)
    }
  } else if (args.squadronFilter && 
    (args.squadronFilter === ALL_SELECT_VALUE || 
      args.squadronFilter !== ALL_SELECT_VALUE
    ) && 
    args.squadronOptions.length > 0) {
      let filter = ''
    args.squadronOptions.forEach((squad) => {
      if(squad.value !== -1 || squad.value !== '') {
        if (filter === '') {
          filter += `((Squadron eq '${squad.value}')`
        } else {
          filter += ` or (Squadron eq '${squad.value}')`
        }
      }
      return
    })
    if (filter !== '') {
      if (((args.roleContext && (
        args.roleContext.isCPOwner || 
        args.roleContext.isAssignedComponentOwner ||
        args.roleContext.isMAJCOMOwner
      )) || !args.roleContext) && 
      args.squadronFilter === ALL_SELECT_VALUE) {
        filter += ' or Squadron eq null)'
      } else {
        filter += ')'
      }
    }
    filters.push(filter)
  }
  
  if (
    args.servicingMAJCOMFilter &&
    args.servicingMAJCOMFilter !== ALL_SELECT_VALUE
  ) {
    if ((args.roleContext && (args.roleContext.isCPOwner || 
      args.roleContext.isAssignedComponentOwner))) {
      filters.push(`ServicingMAJCOMCode eq ${args.servicingMAJCOMFilter}`)
    } else if (!args.roleContext) {
      filters.push(`ServicingMAJCOMCode eq ${args.servicingMAJCOMFilter} or ServicingMAJCOMCode eq null`)
    }
  } else if (args.servicingMAJCOMFilter && 
    args.servicingMAJCOMFilter === ALL_SELECT_VALUE && 
    args.majcomOptions.length > 0) {
      let filter = ''
      
    args.majcomOptions.forEach((majcom) => {
      if(majcom.value !== -1) {
        if (filter === '') {
          filter += `((ServicingMAJCOMCode eq ${majcom.value} and AssignedComponentCode eq ${majcom.assignedComponentCode})`
        } else {
          filter += ` or (ServicingMAJCOMCode eq ${majcom.value} and AssignedComponentCode eq ${majcom.assignedComponentCode})`
        }
      }
      return
    })
    if (filter !== '') {
      if (((args.roleContext && (args.roleContext.isCPOwner || 
        args.roleContext.isAssignedComponentOwner)) || !args.roleContext)) {
        filter += ' or ServicingMAJCOMCode eq null)'
      } else {
        filter += ')'
      }
    }
    filters.push(filter)
  }

  if (
    args.assignedComponentFilter &&
    args.assignedComponentFilter !== ALL_SELECT_VALUE
  ) {
    if (args.roleContext && (args.roleContext.isCPOwner || 
      args.roleContext.isAssignedComponentOwner)) {
      filters.push(`(AssignedComponentCode eq ${args.assignedComponentFilter})`)
    } else if (!args.roleContext) {
      filters.push(`AssignedComponentCode eq ${args.assignedComponentFilter} or AssignedComponentCode eq null`)
    }
  } else if (args.assignedComponentFilter && 
    args.assignedComponentFilter === ALL_SELECT_VALUE && 
    args.assignedComponentOptions.length > 0) {
    let filter = ''
    args.assignedComponentOptions.forEach((ac) => {
      if(ac.value !== -1) {
        if (filter === '') {
          filter += `(AssignedComponentCode eq ${ac.value}`
        } else {
          filter += ` or AssignedComponentCode eq ${ac.value}`
        }
      }
      return
    })
    if (filter !== '') {
      if ((args.roleContext && (args.roleContext.isCPOwner || 
        args.roleContext.isAssignedComponentOwner) || !args.roleContext) && 
        args.assignedComponentFilter === ALL_SELECT_VALUE) {
        filter += ' or AssignedComponentCode eq null)'
      } else {
        filter += ')'
      }
    }    
    filters.push(filter)
  }
  const filter = and(...filters)
  return filter
}
const convertServerObject = (item: QuickLinks): QuickLinks => ({
  ...item,
  'Section/MetadataValue': item['Section/MetadataValue']
    ? item['Section/MetadataValue']
    : ALL_SELECT_LABEL,
})
const getQuickLinks = async (args: QuickLinksArgs): Promise<QuickLinks[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructQuickLinksFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
      COLUMN_NAMES.SectionCodes,
      COLUMN_NAMES.Title,
      COLUMN_NAMES.eKey,
      COLUMN_NAMES.eTag,
      COLUMN_NAMES.AssignedComponentCode,
      COLUMN_NAMES.ServicingMAJCOMCode,
      COLUMN_NAMES.Url,
      'AssignedComponent/MetadataValue',
      COLUMN_NAMES.Section,
      COLUMN_NAMES.Squadron,
      'ServicingMAJCOM/MetadataValue'
    )
    .expand(
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModifiedBy,
      'AssignedComponent',
      'ServicingMAJCOM'
    )
    .orderBy([{ ascending: false, orderBy: COLUMN_NAMES.ItemModified }])
    .get()
    items.forEach((element: QuickLinks) => {
      element.Section = JSON.parse(element.Section)
      element.SectionCodes = JSON.parse(element.SectionCodes)
    })

    return [...items] as QuickLinks[]
  }
const addOrUpdateQuickLink = async (addObj): Promise<void> => {
  try {
    const andList = await mpfRListsHttp().getList(LIST_NAME)
    await andList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error(error)
  }
}

const deleteQuickLink = async (quicklink): Promise<void> => {
  try {
    const lists = await mpfRListsHttp().getList(LIST_NAME)
    await lists.deleteItem(quicklink.eKey, quicklink.eTag)
  } catch (error) {
    console.error(`Problem Deleting Quick Link: ${error}`)
  }
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type QuickLinks,
  type QuickLinksArgs,
  addOrUpdateQuickLink,
  deleteQuickLink,
  getQuickLinks,
}
